// Small helpers shared by the popup, deal cards, hero slide, strip and /offers pages.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function shortDate(dateStr) {
  if (!dateStr) return '';
  const [, m, d] = String(dateStr).slice(0, 10).split('-').map(Number);
  return `${d} ${MONTHS[m - 1]}`;
}

/** "ends 30 Nov" / "ends in 3 days" / "ends today" */
export function endsLabel(endDate) {
  if (!endDate) return '';
  const today = new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);
  const days = Math.round((Date.parse(`${endDate}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / 86400000);
  if (days <= 0) return 'ends today';
  if (days <= 7) return `ends in ${days} day${days === 1 ? '' : 's'}`;
  return `ends ${shortDate(endDate)}`;
}

/** Where an offer's main CTA goes: straight to the only property, else its offer page. */
export function offerPath(offer) {
  if (!offer) return '/offers';
  if (offer.propertyCount === 1 && offer.propertyIds?.[0]) {
    return `/property/${offer.propertyIds[0]}?coupon=${encodeURIComponent(offer.code)}`;
  }
  return `/offers/${encodeURIComponent(offer.slug || offer.code)}`;
}

export function exploreAllPath(offer) {
  return `/properties?coupon=${encodeURIComponent(offer.code)}`;
}

export function stayWord(offer, count = offer?.propertyCount) {
  return count === 1 ? 'stay' : 'stays';
}

/** "See the 12 offer stays" — or the admin's own button text. */
export function ctaLabel(offer) {
  if (offer?.theme?.ctaLabel) return offer.theme.ctaLabel;
  if (offer?.propertyCount === 1) return 'See the offer stay';
  return `See the ${offer?.propertyCount || ''} offer ${stayWord(offer)}`.replace(/\s+/g, ' ');
}

export const OFFER_STYLES = {
  navy: { bg: 'linear-gradient(135deg, #0D1F3C 0%, #162c52 48%, #1a3a6e 100%)', ink: '#FFBD59' },
  festive: { bg: 'linear-gradient(135deg, #8f1d2c 0%, #c4313a 100%)', ink: '#FFD88A' },
  monsoon: { bg: 'linear-gradient(135deg, #123d2e 0%, #2f6b4f 100%)', ink: '#C8F2D6' },
};

export function offerStyle(offer) {
  return OFFER_STYLES[offer?.theme?.style] || OFFER_STYLES.navy;
}

export async function copyText(text) {
  try {
    await navigator.clipboard?.writeText(text);
    return true;
  } catch {
    return false;
  }
}
